<template>
  <div class="page-header">
    <div class="page-header__main">
      <div>
        <span v-if="eyebrow" class="page-header__eyebrow">{{ eyebrow }}</span>
        <h1 class="page-header__title">
          {{ title }}
          <span v-if="badge" class="tag is-warning is-light">{{ badge }}</span>
        </h1>
      </div>
      <div class="page-header__actions">
        <slot name="content-actions" />
        <router-link v-if="to" :to="to">
          <button class="button is-intelligential">{{ returnText }}</button>
        </router-link>
        <button v-if="action" class="button is-intelligential" @click="action">
          Agregar
        </button>
      </div>
    </div>
    <div v-if="returnText && returnTo" class="page-header__return">
      <router-link :to="{ name: returnTo }">
        <i class="fas fa-angle-left"></i> {{ returnText }}
      </router-link>
    </div>
    <div v-if="returnText && returnToFunction" class="page-header__return">
      <label @click="returnToFunction">
        <i class="fas fa-angle-left"></i> {{ returnText }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleBar',
  props: {
    title: {
      type: String,
      required: true
    },
    eyebrow: {
      type: String,
      default: null
    },
    badge: {
      type: String,
      default: null
    },
    to: {
      type: Object,
      default: null
    },
    action: {
      type: Function,
      default: null
    },
    slotData: {
      type: Boolean,
      default: false
    },
    returnText: {
      type: String,
      default: null
    },
    returnTo: {
      type: String,
      default: null
    },
    returnToFunction: {
      type: Function,
      default: null
    }
  }
}
</script>
